import CryptoJS from 'crypto-js'

export default {
  encrypt: function (value) {
    return CryptoJS.AES.encrypt(value.toString(), process.env.CRYPTO_KEY).toString();
  },
  decrypt: function (value) {
    const bytes = CryptoJS.AES.decrypt(value, process.env.CRYPTO_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  },
  decryptFromBack: function (value) {
    var base64Key = process.env.JAVA_DECRYPT_KEY;
    var key = CryptoJS.enc.Base64.parse(base64Key);
    var decryptedData = CryptoJS.AES.decrypt(value, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    var decryptedText = decryptedData.toString( CryptoJS.enc.Utf8 );

    return decryptedText;
  },
  encode: function(value, expiration) {
    let jwt = require('jsonwebtoken');

    if (expiration) {
      return jwt.sign(value, process.env.TOKEN_SECRET, { expiresIn: expiration * 1000 });
    } else {
      return jwt.sign(value, process.env.TOKEN_SECRET);
    }
  },
  decode: function(token, isJson) {
    if (token) {
      let jwt = require('jsonwebtoken');
      let tokenObject = null;
      try {
        tokenObject = jwt.verify(token, `${process.env.TOKEN_SECRET}`);
      } catch (error) {
        return null;
      }
      let content = isJson ? JSON.parse(tokenObject.content) : tokenObject.content;

      return content;
    } else {
      return null;
    }
  }
}


// WEBPACK FOOTER //
// ./src/helpers/cipher.js